var prodcat = prodcat || {};
var site = site || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId, hasDramming) {
    var $product = $(this);
    var $shadesGrid = $product.find('.js-product-full-shades-grid');
    var $selectedShade = $shadesGrid.find('.js-product-full-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]');
    var $activeShade = $product.find('.js-product-full-shades-overlay__selected-shade');
    var $activeShadeDot = $activeShade.find('.js-shade-dot');
    var styles = {
      backgroundColor: $selectedShade.data('hex'),
      borderColor: $selectedShade.data('hex')
    };

    // Don't execute only on init for dramming product
    if (hasDramming === 'noshade') {
      return;
    }

    if ($shadesGrid.length < 1) {
      return null;
    }
    $product.data('sku-base-id', skuBaseId);
    if (hasDramming) {
      $product.find('.js-shade-dot.drammingactive').removeClass('drammingactive');
      $activeShadeDot.css(styles).addClass('drammingactive');
    } else {
      $product.find('.js-shade-dot').not('.drammingactive');
      $activeShadeDot.css(styles);
    }
  });

  Drupal.behaviors.productFullShadesoverlayV2 = {
    toggleShade: false,
    drammingPage: false,
    attached: false,
    attach: function (context) {
      var self = this;
      var $overlay = $('.js-product-full-shades-flyout-v2', context);
      var $shadeItem = $('.js-product-full-shades-overlay-list-item', $overlay);
      var $shadesGrid = $('.js-product-full-shades-grid', $overlay);
      var $flyoutTrigger = $('.js-product-full-shades-flyout-trigger', context);
      var $overlayCloser = $('.js-product-full-shades-overlay-close', $overlay);
      var $selectCTA = $('.js-shade-select', $overlay);

      if (self.attached) {
        return;
      }
      self.attached = true;

      if ($('.js-second-shade-select-option').length > 0) {
        self.drammingPage = true;
      }

      $selectCTA.once().on('click', function () {
        $overlayCloser.trigger('click');
      });

      $overlayCloser.once().on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('overlay-shades-active');
      });

      if ($flyoutTrigger.length) {
        $flyoutTrigger.once().on('click', function () {
          var $flyoutCta = $(this);
          var $perfectMatchTab = $('.js-product-full-shade--perfect-match', $overlay);
          $('body').addClass('overlay-shades-active');

          if ($perfectMatchTab.length > 0 && $('.js-sku-shade-name', $flyoutCta).hasClass('perfect-match-txt')) {
            $perfectMatchTab.trigger('productShade:choosePerfectMatch');
          } else if ($perfectMatchTab.length > 0 && $perfectMatchTab.hasClass('active')) {
           $('.js-product-full-shade--filter').filter('.active').trigger('click');
          }
          //Scroll into view visible selection
          if ($shadeItem.filter('.active.hidden').last().length === 0) {
            $overlay.scrollTop(0);
            setTimeout(function(){
              $overlay.animate({
                scrollTop: $shadeItem.filter('.active').last().position().top + $overlay.scrollTop()
                }, 'slow');
              }, 300);
          }
        });
      }

    },
    orderAlphabetical: function ($shadeItem, $shadesGrid) {
      $shadeItem.sort(function (a, b) {
        var aShade = $(a).data('shade-name');
        var bShade = $(b).data('shade-name');

        return aShade < bShade ? -1 : aShade > bShade ? 1 : 0;
      }).appendTo($shadesGrid);
    }
  };
})(jQuery);
